import React from 'react'
// import { useTranslation } from 'react-i18next';
import { useParams /*, useHistory */ } from 'react-router-dom'
import TopNavigation from '../../TopNavigation'
import { Container } from 'reactstrap'
import { useSelector } from 'react-redux'
import { Box, Button, Chip, Divider, Grid, Typography, TextField } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import withAppconfig from '../../AppContext'
// import { getLastvalidDate } from './MembershipUtil'
import { connect } from 'react-redux'
// import ProfileInput from '../../components/ProfileInput'
import Poster from '../../components/Poster'
import PlusMinusButton from '../../components/Shop/PlusMinusButton'
import moment from 'moment'
import 'moment/locale/fi' // Import Finnish locale for moment.js

const enhance = connect(({ globaltime: { gtime } }) => ({
  gtime,
}))

// Grid based component for adding event tickets to the cart and checkout
function EventTicketVariationSelector({
  variations,
  onUpdate,
  ticketVariantAmounts,
}) {
  const handleChange = (varid, amount) => {
    const newAmounts = { ...ticketVariantAmounts, [varid]: amount }
    onUpdate(newAmounts)
  }

  return (
    <Grid container spacing={2} style={{ marginTop: 20 }}>
      {variations.map((v) => {
        const maxAmount = (v.ticketsavailable || 0) - (v.quantity || 0)
          return (
            <React.Fragment key={v.id + '-fragment'}>
              <Grid item xs={5} key={v.id + '-name'}>
                <Typography variant='h6' component='span' style={{ marginRight: 10 }}>
                  {v.name}
                </Typography>
              </Grid>
              <Grid item xs={3} key={v.id + '-price'}>
                <Typography variant='body2' component='span' style={{ marginRight: 10 }}>
                  {`${(v.price / 100)
                    .toFixed(2)
                    .replace('.', ',')} € / kpl`}
                </Typography>
              </Grid>
              <Grid item xs={4} key={`input-${v.id}`} style={{ textAlign: 'right' }}>
                {maxAmount <= 0 ? (
                  <Typography variant='body2' style={{ color: '#888' }}>
                    {v.soldOutText || 'Loppuunmyyty'}
                  </Typography>
                ) : (
                <PlusMinusButton
                  onChange={(amount) => handleChange(v.id, amount)}
                  loading={false}
                  max={maxAmount}
                  />
                )}
              </Grid>
              <Grid item xs={12} key={`divider-${v.id}`}>
                <Typography variant='caption' style={{ color: '#888' }}>
                  {v.description || 'Ei lisätietoja'}
                </Typography>
                <Divider style={{ margin: '10px 0' }} />
              </Grid>
            </React.Fragment>
          )
      })}
    </Grid>
  )
}

function EventTicketScreen({ appconfig, gtime }) {
  const params = useParams()
  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation()
  const [ticketVariantAmounts, setTicketVariantAmounts] = React.useState({})
  // const [profileIsValid, setProfileIsValid] = React.useState(false)
  const eventTicket = useSelector((state) => {
    return (
      state.firebase.data.shopeventtickets &&
      state.firebase.data.shopeventtickets[params.id]
    )
  })

  if (!eventTicket) {
    return <Typography variant='h5'>{t('eventticket_not_found')}</Typography>
  }
  // if (eventTicket === undefined) return history.push(appconfig.pathPrefix + '/shop/tickets')
  const { poster, variations } = eventTicket
  if (
    Object.keys(ticketVariantAmounts).length === 0 &&
    variations &&
    variations.length > 0
  ) {
    const initialAmounts = {}
    variations.forEach((v) => {
      initialAmounts[v.id] = 0
    })
    setTicketVariantAmounts(initialAmounts)
  }

  // let variationsSelector = null
  // if (eventTicket.variations) {
  //   if (eventTicket.variations.length > 1) {
  //     variationsSelector = eventTicket.variations.map((v) => {
  //       return (
  //         <Chip
  //           clickable
  //           label={v.name}
  //           key={'varid-' + v.varid}
  //           color={selectedVariant?.varid === v.varid ? 'primary' : 'default'}
  //           variant={selectedVariant?.varid === v.varid ? 'outlined' : 'default'}
  //           onClick={() => setSelectedVariant(v)}
  //           style={{ margin: 5 }}
  //         />
  //       )
  //     })
  //   } else {
  //     variationsSelector = <Typography variant='h5'>{eventTicket.variations[0].name}</Typography>
  //     if (selectedVariant === null) {
  //       setSelectedVariant(eventTicket.variations[0])
  //     }
  //   }
  // }

  const goToPay = (ticket) => {
    ticket.type = 'eventticket'
    dispatch({
      type: 'UPDATE_PAYABLE_EVENTTICKET',
      payload: ticket,
    })
    history.push(appconfig.pathPrefix + '/tickets/checkout')
  }

  // let lastvalidDate = getLastvalidDate(eventTicket.validity, gtime)
  // if (lastvalidDate === 'permanent') {
  //   lastvalidDate = t('permanent')
  // } else {
  //   lastvalidDate = t('valid') + ' ' + lastvalidDate.format('D.M.YYYY')
  // }

  return (
    <div className='full-page-background'>
      <TopNavigation />
      <Container className='front' style={{ paddingTop: 10 }}>
        <Grid container spacing={3} alignItems='flex-start'>
          <Grid
            item
            xs={12}
            md={6}
            style={{ textAlign: 'center', paddingTop: 40 }}
          >
            <Poster
              data={poster}
              preferredSize={1080}
              alt={eventTicket.displayName}
              defaultBg={appconfig.logos}
              style={{ width: '100%' }}
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            style={{ paddingTop: '5em', paddingRight: 20 }}
          >
            <Typography variant='h4'>
              {eventTicket.displayName.toUpperCase()}
            </Typography>
            <Typography variant='subtitle1' style={{ marginTop: 10 }}>{moment(eventTicket.start).format('D.M.YY H:mm')}</Typography>
            { eventTicket.address && (
              <Typography variant='subtitle1' style={{ marginTop: 10 }}>
                {eventTicket.address}
              </Typography>
            )}
            <Divider />
            {/* {variationsSelector} */}
            {/* <div>
              <Typography variant='h6'>
                {selectedVariant ? (selectedVariant.price / 100).toFixed(2).replace('.', ',') + ' €' : null}
              </Typography>
              <Typography variant='caption'>
                {selectedVariant ? t('vat') + ' ' + eventTicket.vat + ' %' : null}
              </Typography>
            </div> */}
            <EventTicketVariationSelector
              variations={variations}
              onUpdate={setTicketVariantAmounts}
              ticketVariantAmounts={ticketVariantAmounts}
            />
            <Box style={{ marginTop: 20 }}>
              <Typography variant='subtitle1'>
                {t('total_price') + ': '}
                <span style={{ fontWeight: 'bold' }}>
                  {Object.keys(ticketVariantAmounts).reduce((total, key) => {
                    const amount = ticketVariantAmounts[key] || 0
                    const price = variations.find((v) => v.id === key)?.price || 0
                    return total + (amount * price) / 100
                  }, 0)
                    .toFixed(2)
                    .replace('.', ',') + ' €'}
                </span>
              </Typography>
              <Typography variant='caption' style={{ color: '#888' }}>
                {t('vat') + ' ' + eventTicket.vat + ' %'}
              </Typography>
            </Box>
            <Button
              variant='contained'
              color='primary'
              disabled={
                !Object.keys(ticketVariantAmounts).some(
                  (key) => ticketVariantAmounts[key] > 0
                )
              }
              style={{ marginTop: 10, marginBottom: 10 }}
              onClick={() => goToPay({ ...eventTicket, ticketVariantAmounts })}
            >
              {t('buy')}
            </Button>
            <Divider />
            <Typography variant='body1'>
              <span
                dangerouslySetInnerHTML={{ __html: eventTicket.description }}
              />
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}

export default withAppconfig(enhance(EventTicketScreen))
